var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasSettings || _vm.hasAnyAccess
    ? _c("div", { staticClass: "flex-shrink-2 ml-1" }, [
        _c("div", { staticClass: "dropdown" }, [
          _c("i", {
            staticClass: "fas fa-ellipsis-v cursor-pointer",
            attrs: { "data-toggle": "dropdown", "aria-expanded": "false" },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dropdown-menu" },
            _vm._l(_vm.settings, function (setting) {
              return _vm.inAvailableType(setting) && _vm.hasAccess(setting)
                ? _c(setting.component, {
                    key: setting.event,
                    tag: "component",
                    attrs: { message: _vm.message, url: setting.formData },
                  })
                : _vm._e()
            }),
            1
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }